import * as React from 'react';

import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import { langDir } from 'js/lib/language';

import { ClientSideEmotionCacheProvider } from '@coursera/cds-core';

import PageFooter from 'bundles/page-footer/components/PageFooter';
import PageHeader from 'bundles/page-header/components/PageHeader';
import type { Stores } from 'bundles/premium-certificate/appEnv';

import _t from 'i18n!nls/premium-certificate';

import 'css!bundles/premium-certificate/__styles__/index';

type Props = {
  requestCountryCode?: string | null;
  csrfToken?: string | null;
};

const PremiumCertificateApp: React.LegacyFunctionComponentWithChildren<Props> = ({ children }) => (
  <ClientSideEmotionCacheProvider direction={langDir(_t.getLocale())}>
    <div data-test="PremiumCertificateApp">
      <PageHeader isPageWithSecondaryCta isScrollable={true} logoWrapper="div" />
      {children}
      <PageFooter />
    </div>
  </ClientSideEmotionCacheProvider>
);

export default connectToStores<Props, {}, Stores>(['ApplicationStore'], ({ ApplicationStore }, props) => ({
  ...props,
  csrfToken: ApplicationStore.getState().csrfToken,
  requestCountryCode: ApplicationStore.getState().requestCountryCode,
}))(PremiumCertificateApp);
